import { AccessLevel } from 'core/utils';

export const isDev = () => {
	const env = process.env.NODE_ENV;
	const devEnv = env === 'development' || window?.cj?.environment === 'stage';
	if (devEnv) return true;
	const access_level = window?.cj?.user?.access_level;
	if (access_level === AccessLevel.CRATEJOY_ADMIN) return true;
	return false;
};

const devLog = (...args) => {
	if (isDev()) return console.debug(...args);
};

export default devLog;
